<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Клиенты, не посещающие занятия
                </div>
            </div>
            <div class="panel-body pn">
                <div class="dt-panelmenu clearfix">
                    <div class="dataTables_length">
                        <div class="filter-form">
                            Не посещал занятия до
                            <label>
                                <input v-on:change="updateFilter" :disabled="isLoading" min="10" v-model="noVisitDay" class="filter-form-input filter-form-input-small">
                            </label>
                            дней
                        </div>
                        <div class="filter-form">
                            Абонемент
                            <label>
                                <select v-on:change="updateFilter" :disabled="isLoading" v-model="activity" class="form-control input-sm">
                                    <option v-for="(activity, index) in activities" v-bind:key="index" :value="activity.id">
                                        {{activity.name}}
                                    </option>
                                </select>
                            </label>
                        </div>
                        <div class="filter-form">
                            Абонементы
                            <vue-select
                                    v-on:change="updateFilter"
                                    :disabled="isLoading"
                                    :options="subscriptions"
                                    v-model="subscriptionIds"
                                    multiple
                                    :searchable="false"
                                    :reduce="subscription => subscription.id"
                                    label="name"
                                    class="filter-form-select-full-width"
                            />
                        </div>
                    </div>
                </div>
                <table class="table table-striped table-hover datatables table-fixed-header" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>ФИО</th>
                            <th>Телефон</th>
                            <th>e-mail</th>
                            <th>Остаток</th>
                            <th>Подписка</th>
                            <th>Последнее посещение</th>
                            <th>Окончание подписки</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in data" v-bind:key="index">
                            <td>
                              <router-link :to="{name: 'clients-edit', params: {id: row.client_id}}">
                                  {{row.last_name}} {{row.first_name}}
                              </router-link>
                            </td>
                            <td>{{row.phone}}</td>
                            <td>{{row.email}}</td>
                            <td>{{row.count}}</td>
                            <td>{{row.subscription.name}}</td>
                            <td>{{row.last_visit | dateFormat('dd.mm.yyyy hh:mm:ss')}}</td>
                            <td>{{row.expire | dateFormat('dd.mm.yyyy')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import Subscription from "../../models/Subscription";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            VueSelect: () => import('vue-select'),
        },
        async beforeMount() {
            const subscriptionsResponse = await Subscription.getList(1, 999, 'name');

            this.subscriptions = subscriptionsResponse.data.map((subscription) => {
                return {id: subscription.id, name: subscription.name};
            });
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        watch: {
            'subscriptionIds': function() {
                this.load();
            },
        },
        data() {
            return {
                activities: [
                    {id: null, name: 'Не важно'},
                    {id: 1, name: 'Только активные'},
                    {id: 2, name: 'Только НЕ активные'},
                ],
                subscriptions: [],
                subscriptionIds: [1, 2, 3, 4, 7, 8, 10, 11, 12, 14, 16, 17],
                isLoading: false,
                noVisitDay: 21,
                activity: 1,
                data: [],
            };
        },
        methods: {
            async load() {
                this.isLoading = true;

                const reportResponse = await Report.getNoVisitClients(this.noVisitDay, this.activity, this.subscriptionIds);

                this.data = reportResponse.data;
                this.isLoading = false;
            },
            updateFilter() {
                if (this.noVisitDay >= 7) {
                    this.load();
                }
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - клиенты, не посещающие занятия',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
